import React from 'react'
import { useInView } from 'react-intersection-observer'

import CardChat from '../../molecules/card-chat/card-chat'
import ProductsInfoCards from '../products-info-cards/products-info-cards'

import iconUser_1 from '../../../assets/images/section-hygiene/chat-icon-user1.png'
import iconUser_2 from '../../../assets/images/section-hygiene/chat-icon-user2.png'
import iconNosotrasDesk from '../../../assets/images/prebioticos-section/icono_nosotras.png'
import iconNosotrasMb from '../../../assets/images/section-hygiene/chat-icon-nosotras.png'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import './section-hygiene.scss'
import { LOCALE } from '../../../constants/activity-constants'

const ReplicaChile = LOCALE==='es-CL'
const SectionHygiene = () => {
  const [ref, inView] = useInView({ threshold: 0.8, triggerOnce: true })
  const [ref2, inView2] = useInView({ threshold: 1, triggerOnce: true })
  const [ref3, inView3] = useInView({ threshold: 1, triggerOnce: true })
  const isMobile = useMediaQuery()

switch (LOCALE) {
  case 'es-CL':
    return (
      <section className='f-section-hygiene-chile'>
        <section className='f-section-hygiene-chile__section'>
          <div className="f-section-hygiene-chile__container --chat1">
            <p className="f-section-hygiene-chile__text --t1">
              AHORA SÍ, <br />
              <b>
                ¡APRENDAMOS JUNTAS A PROTEGER <br />
                NUESTRA ZONA V CON PRO - DEFENSE V!
              </b>
            </p>
            <div ref={ref}>
              <CardChat
                iconUser={iconUser_1}
                className={`--green --chat-hygiene-1 --width  ${
                  inView ? 'animacion' : ''
                }`}
              >
                <>
                  <b>¿Y qué es Pro - Defense V?,</b>
                  <br />
                  ¿cómo lo debo usar?
                </>
              </CardChat>
            </div>
            <div ref={ref2}>
              <CardChat
                chatNosotras
                iconUser={isMobile?iconNosotrasMb:iconNosotrasDesk}
                className={`--green --big --padding2rem ${
                  inView2 ? 'animacion' : ''
                }`}
              >
                <>
                  <b>
                    Vamos a ir por partes 😀
                    <br /> <br />
                  </b>
                  La Zona V es la más delicada de tu cuerpo y necesita de
                  productos <br />
                  <b>
                    ginecológicamente testeados y dermatológicamente comprobados
                  </b>
                  <br />
                  para protegerte de verdad. Por eso,{' '}
                  <b>¡Pro - Defense V llega para cuidarte!</b>
                </>
              </CardChat>
            </div>
          </div>
        </section>
        <section className="f-section-hygiene-chile__section">
          <p className="f-section-hygiene-chile__text --t2">
            ¡TENEMOS UNA RUTINA <br />
            DE HIGIENE PARA TI!
          </p>
          <br />
          <ProductsInfoCards />
        </section>
        <section className="f-section-hygiene-chile__section">
          <div className="f-section-hygiene-chile__container --chat1">
            <p className="f-section-hygiene-chile__text --t3">
              <b>
                Imagínate que además, nuestros productos Pro - Defense V<br />{' '}
                cuentan con ácido láctico,{'\u00A0'}
              </b>
              un ingrediente natural que no altera <br />
              el pH de tu Zona V.
            </p>
            <div ref={ref3}>
              <CardChat
                iconUser={iconUser_2}
                className={`--green --big --img-autowidth  --chat-hygiene-3 ${
                  inView3 ? 'animacion' : ''
                }`}
              >
                <span style={{ fontSize: '32px' }}>
                  {isMobile ? '\u00A0 \u00A0 \u00A0' : ''}😮😊
                </span>
                <br />
                <b>
                  <br />
                  ¡Ahora mi Zona V ya no estará indefensa! Porque voy a evitar que
                  se altere con Pro Defense-V
                </b>
              </CardChat>
            </div>
          </div>
        </section>
      </section>
    )

  default:
    return (
      <section className='f-section-hygiene'>
        <section className='f-section-hygiene__section'>
          <div className="f-section-hygiene__container --chat1">
            <p className="f-section-hygiene__text --t1">
              AHORA SÍ, <br />
              <b>
                ¡APRENDAMOS JUNTAS A PROTEGER <br />
                NUESTRA ZONA V CON PRO - DEFENSE V!
              </b>
            </p>
            <div ref={ref}>
              <CardChat
                iconUser={iconUser_1}
                className={`--green --chat-hygiene-1 --width  ${
                  inView ? 'animacion' : ''
                }`}
              >
                <>
                  <b>¿Y qué es Pro - Defense V?,</b>
                  <br />
                  ¿cómo lo debo usar?
                </>
              </CardChat>
            </div>
            <div ref={ref2}>
              <CardChat
                chatNosotras
                iconUser={isMobile?iconNosotrasMb:iconNosotrasDesk}
                className={`--green --big --padding2rem ${
                  inView2 ? 'animacion' : ''
                }`}
              >
                <>
                  <b>
                    Vamos a ir por partes 😀
                    <br /> <br />
                  </b>
                  La Zona V es la más delicada de tu cuerpo y necesita de
                  productos <br />
                  <b>
                    ginecológicamente testeados y dermatológicamente comprobados
                  </b>
                  <br />
                  para protegerte de verdad. Por eso,{' '}
                  <b>¡Pro - Defense V llega para cuidarte!</b>
                </>
              </CardChat>
            </div>
          </div>
        </section>
        <section className="f-section-hygiene__section">
          <p className="f-section-hygiene__text --t2">
            ¡TENEMOS UNA RUTINA <br />
            DE HIGIENE PARA TI!
          </p>
          <br />
          <ProductsInfoCards />
        </section>
        <section className="f-section-hygiene__section">
          <div className="f-section-hygiene__container --chat1">
            <p className="f-section-hygiene__text --t3">
              <b>
                Imagínate que además, nuestros productos Pro - Defense V<br />{' '}
                cuentan con ácido láctico,{'\u00A0'}
              </b>
              un ingrediente natural que no altera <br />
              el pH de tu Zona V.
            </p>
            <div ref={ref3}>
              <CardChat
                iconUser={iconUser_2}
                className={`--green --big --img-autowidth  --chat-hygiene-3 ${
                  inView3 ? 'animacion' : ''
                }`}
              >
                <span style={{ fontSize: '32px' }}>
                  {isMobile ? '\u00A0 \u00A0 \u00A0' : ''}😮😊
                </span>
                <br />
                <b>
                  <br />
                  ¡Ahora mi Zona V ya no estará indefensa! Porque voy a evitar que
                  se altere con Pro Defense-V
                </b>
              </CardChat>
            </div>
          </div>
        </section>
      </section>
    )
}

  
}

export default SectionHygiene
